import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Button, FormControl, FormLabel, Input, Stack, chakra } from '@chakra-ui/react';
import { PasswordField } from './PasswordField';
export var LoginForm = function LoginForm(props) {
  return /*#__PURE__*/_jsx(chakra.form, {
    onSubmit: function onSubmit(e) {
      var _elements$email, _elements$password, _elements$fullName;

      e.preventDefault();
      var email = (_elements$email = e.target.elements.email) === null || _elements$email === void 0 ? void 0 : _elements$email.value;
      var password = (_elements$password = e.target.elements.password) === null || _elements$password === void 0 ? void 0 : _elements$password.value;
      var fullName = (_elements$fullName = e.target.elements.fullName) === null || _elements$fullName === void 0 ? void 0 : _elements$fullName.value;
      props.onSubmit({
        email: email,
        password: password,
        fullName: fullName
      });
    },
    children: /*#__PURE__*/_jsxs(Stack, {
      spacing: "6",
      children: [props.collectName && /*#__PURE__*/_jsxs(FormControl, {
        id: "fullName",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          children: "Full Name"
        }), /*#__PURE__*/_jsx(Input, {
          name: "fullName",
          type: "text",
          autoComplete: "name",
          required: true
        })]
      }), /*#__PURE__*/_jsxs(FormControl, {
        id: "email",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          children: "Email address"
        }), /*#__PURE__*/_jsx(Input, {
          name: "email",
          type: "email",
          autoComplete: "email",
          required: true
        })]
      }), /*#__PURE__*/_jsx(PasswordField, {
        allowMagic: props.allowMagic
      }), /*#__PURE__*/_jsx(Button, {
        isLoading: props.isLoading,
        type: "submit",
        colorScheme: "blue",
        size: "lg",
        fontSize: "md",
        children: props.label || 'Sign in'
      })]
    })
  });
};